import React from 'react'
import {Flex, Button, Img, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'
import {FormattedMessage} from 'react-intl'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'

const RecipeUtilityTile = ({styles, tile}) => {
    const navigate = useNavigation()

    const handleNavigateToPdp = () => {
        navigate(tile?.c_slugUrl)
    }

    return (
        <Flex
            maxW={{base: '100%', lg: remCalc(168)}}
            maxH={{base: 'unset', lg: remCalc(380)}}
            data-testid="made-with-tile-testid"
            {...styles.tile}
            marginBottom={{base: 'xsmall.base', md: 'xsmall.lg'}}
        >
            <Flex {...styles.tile?.imagecontainer}>
                <Img
                    src={tile?.imageGroups?.[0]?.['images']?.[0]?.link}
                    alt={tile?.imageGroups?.[0]?.['images']?.[0]?.alt || ''}
                />
            </Flex>
            <Flex {...styles.tile?.imagecontainer}></Flex>
            <Flex gap="xsmall.base" flexDir="column" minH={remCalc(60)}>
                <Text
                    textStyle="head-xxsmall"
                    overflow="hidden"
                    display="-webkit-box"
                    sx={{
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                    }}
                    textOverflow="ellipsis"
                    fontWeight="medium"
                    textAlign="center"
                    minH={remCalc(40)}
                >
                    {tile?.c_defaultName}
                </Text>
                <Text
                    textStyle="body-xsmall"
                    fontWeight="normal"
                    color="text.secondary"
                    textAlign="center"
                >
                    <Text>{tile?.name}</Text>
                </Text>
            </Flex>
            <Flex maxW={remCalc(122)} justifyContent="center" alignSelf="center">
                <Button
                    onClick={handleNavigateToPdp}
                    variant="primary"
                    textStyle="body-xsmall"
                    fontWeight="medium"
                    paddingY={remCalc(12)}
                    paddingX="small.base"
                >
                    <FormattedMessage
                        id="recipes.details_page.carousel.discover_more"
                        defaultMessage="Discover More"
                    />
                </Button>
            </Flex>
        </Flex>
    )
}

RecipeUtilityTile.propTypes = {
    tile: PropTypes.shape({
        c_defaultName: PropTypes.string,
        name: PropTypes.string,
        shortDescription: PropTypes.string,
        uid: PropTypes.string,
        image: PropTypes.string,
        imageGroups: PropTypes.array,
        c_slugUrl: PropTypes.string,
    }),
    styles: PropTypes.shape(),
}

export default RecipeUtilityTile
